import dayjs from 'dayjs';
import { addNotify } from 'features/notify';

const actionTypes = {
  ACTION_PROCESSING: 'topUp/ACTION_PROCESSING',
  GET_TOPUP_REQUESTS_SUCCESS: 'topUp/GET_TOPUP_REQUESTS_SUCCESS',
};

function getTopUpRequests(info) {
  return async (dispatch, getState, extra) => {
    dispatch({ type: actionTypes.ACTION_PROCESSING, payload: true });
    const { api } = extra;
    const locale = getState().locale.locale;
    const response = await api.withdrawal.getTopUpRequests(info);

    if (response.success) {
      dispatch({ type: actionTypes.GET_TOPUP_REQUESTS_SUCCESS, payload: response.data });
    } else {
      const errorMessage = locale[response.codeStatus] ?? locale.defaultMessage;
      dispatch(addNotify(errorMessage, 'error'));
    }

    dispatch({ type: actionTypes.ACTION_PROCESSING, payload: false });
  };
}

function resolveTopUpCard(info, callback) {
  return async (dispatch, getState, extra) => {
    dispatch({ type: actionTypes.ACTION_PROCESSING, payload: true });
    const { api } = extra;
    const locale = getState().locale.locale;
    const response = await api.withdrawal.resolveTopUpCard(info);

    if (response.success) {
      dispatch(addNotify(locale.defaultSuccess, 'success'));
    } else {
      const errorMessage = locale[response.codeStatus] ?? locale.defaultMessage;
      dispatch(addNotify(errorMessage, 'error'));
    }

    if (callback) callback();
    dispatch({ type: actionTypes.ACTION_PROCESSING, payload: false });
  };
}

export { actionTypes, getTopUpRequests, resolveTopUpCard };
